import React from 'react';
import './BackButton.scss';

const BackButton = ({
  onClick = () => {},
  text = 'חזור',
  className = '',
  disabled = false
}) => {
  return (
    <button
      className={`back-button`}
      onClick={onClick}
      disabled={disabled}
      type="button"
    >
      <div className="back-button-content">
        <svg
          className="back-arrow"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M9 18L15 12L9 6"
            stroke="var(--theme-primary, #810EA9)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="back-text">{text}</span>
      </div>
    </button>
  );
};

export default BackButton;
